/* AYRON Richness Pass — scroll-triggered section reveal.
   Progressive enhancement: if JS doesn't run, or the visitor prefers
   reduced motion, sections simply render at full opacity as normal —
   nothing depends on this script for content to be visible. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var main = document.getElementById('MainContent');
  if (!main) return;

  var sections = main.querySelectorAll(':scope > .shopify-section');
  if (!sections.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
  );

  sections.forEach(function (el, index) {
    // Don't fade the very first section (usually the hero) — it should be
    // visible immediately on load, not wait for a scroll trigger.
    if (index === 0) return;
    el.classList.add('ayr-reveal');
    observer.observe(el);
  });
})();
